import { inject, Injectable, signal } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
} from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { type BreadcrumbItem } from '../routing/view-header.types';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class ViewHeaderService {
  private readonly router = inject(Router);
  breadcrumbs = signal<BreadcrumbItem[]>([]);

  constructor() {
    this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const leaf = this.leafRouteSnapshot(
          this.router.routerState.snapshot.root,
        );
        const viewHeader = leaf.data['viewHeader'] as
          | { breadcrumbs?: BreadcrumbItem[] }
          | undefined;
        this.breadcrumbs.set(viewHeader?.breadcrumbs ?? []);
      }
    });
  }

  private leafRouteSnapshot(root: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let route = root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  setBreadcrumbs(breadcrumbs: BreadcrumbItem[]) {
    this.breadcrumbs.set(breadcrumbs);
  }
}
